module.exports = __webpack_public_path__ + "media/Video 10c.b1f80c10.mp4";